export const MAGIC_LINK_VALUES = ['default', 'enabled', 'disabled'] as const;

export const magicLinkToFormValue = (value: boolean | null | undefined): string => {
  if (value === true) return 'enabled';
  if (value === false) return 'disabled';
  return 'default';
};

export const formValueToMagicLink = (value: string): boolean | null => {
  if (value === 'enabled') return true;
  if (value === 'disabled') return false;
  return null;
};
